import { render, staticRenderFns } from "./EmergencyPage.vue?vue&type=template&id=a248fb4a&"
import script from "./EmergencyPage.vue?vue&type=script&lang=js&"
export * from "./EmergencyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports